"use strict";

import {createAjaxForm} from "@c0necto/elements-ajax-form";
import {onFind, cleanUpInScope} from "@c0necto/elements-init-modules-in-scope";
import {find, findAllIn, findIn, on, hasClass, trigger} from "@c0necto/elements-dom-utils";
import {addRoom} from "./quickfinder-room";
import {createLeafletMap,getApi} from "@c0necto/elements-leaflet-map";
import fetch from '@c0necto/elements-fetch';
import formDataEntries from 'form-data-entries';
import 'url-polyfill';
import 'url-search-params-polyfill'; // Edge Polyfill
import {NSerializeJson} from "nserializejson";

const infoBoxOptions = {
    maxWidth: matchMedia('(max-width: 767px)').matches ? 240 : 320,
    minWidth: matchMedia('(max-width: 767px)').matches ? 220 : 300,
    className: 'map-infobox'
};

export function init () {

    onFind('.js-ajax-form-map-leaflet', function (baseElement) {

        let form = findIn('.js-ajax-form-map-leaflet__form', baseElement);
        let mapCanvas = findIn('.js-ajax-form-map-leaflet__canvas', baseElement);

        createAjaxForm(baseElement, {
            allowScriptTags: true
        }, {
            result: '.js-ajax-form-map-leaflet__result',
            loading: '.js-ajax-form-map-leaflet__loading',
            notifications: '.js-ajax-form-map-leaflet__notifications',
            form: '.js-ajax-form-map-leaflet__form',
            additionalForm: '.js-ajax-form-map-leaflet__additional-form',
            errorArea: '.js-ajax-form-map-leaflet__error-area',
            retry: '.js-ajax-form-map-leaflet__retry',
            link: '.js-ajax-form-map-leaflet__link',
            reset: '.js-ajax-form-map-leaflet__reset',
        });

        if (mapCanvas) {
            initMapCanvas(baseElement);
        }

        on('fetched.ajax-form', (evt) => fetchedHandler(evt), baseElement);
        on('success.ajax-form', (evt) => successHandler(evt, baseElement), baseElement);
        on('reset.ajax-form', (evt) => resetHandler(evt, baseElement), baseElement);
        on('submit.ajax-form', (evt) => submitHandler(evt, baseElement), baseElement);

    });

    const submitHandler = (evt, element) => {

        let form = findIn('.js-ajax-form-map-leaflet__form',element);
        let redirectUrl = form.getAttribute('data-redirect-action');

        // push form data / filter object to dataLayer
        let formData = NSerializeJson.serializeForm(form);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'accommodationFiltered',
            'accommodationFilterObject': formData
        });

        if(redirectUrl && redirectUrl !== 'false'){

            let markupElement = document.createElement('div');
            let formDataEntries = getFormDataEntries(form);

            markupElement.innerHTML = `<form id="redirectForm" action="${redirectUrl}"  method="get">${formDataEntries.map(createInputMarkup).join('')} </form>`;

            let reloadForm = markupElement.childNodes[0];    //remove wrapper-div
            find('body').append(reloadForm);

            window.reloadForm = reloadForm;
            window.reloadForm.submit();

            let redirectOverlay = find('.js-accommodation-filter__redirect-overlay');
            redirectOverlay.removeAttribute('hidden');

        }

    };

    const fetchedHandler = (evt) => {
        _config.filterIdsRequestUrl = evt.detail.filterIdsRequestUrl;
        _config.filterIdsRequestUrlSingle = evt.detail.filterIdsRequestUrlSingle;
    };

    const successHandler = (evt, element) => {
        // addRoom to quickfinder on reinit
        let roomCounter;
        if (find('.js-room-template')){
            roomCounter = parseInt(find('.js-room-template').getAttribute('data-room-counter'));
        }

        // only add initial room when its not prefilled
        if(roomCounter === 0){
            addRoom();
        }

        let mapCanvas = findIn('.js-ajax-form-map-leaflet__canvas', element);

        if (mapCanvas) {
            initMapCanvas(element);
        }

        let scrollOffset = findIn('.js-ajax-form-map-leaflet__result',element).getBoundingClientRect().top + window.scrollY - 140;

        window.scrollTo({
            top: scrollOffset,
            behavior: 'smooth'
        });
    };

    const resetHandler = (evt, element) => {
        trigger('submit',findIn('.js-ajax-form-map-leaflet__form', element));
        let resetInputs = evt.detail;

        // reset typeaheadDefaultValue var only when react select is reseted
        resetInputs.map(input => {
            if (hasClass('react-select__input',input)){
                window.typeaheadDefaultValue = [];
            }
        })
    };
}

function createInputMarkup(param) {
    console.log('param', param)
    return ('<input type="hidden" name="' + param[0] + '" value="' + param[1] + '">')
}

function getFormDataEntries(form) {
    let formDataArray = [];

    // unchecked checkboxes and radios needs to be added manually to formDataArray
    let selectors = findAllIn('input[type="radio"], input[type="checkbox"]', form);
    let selectorNames = [];

    selectors.map(function(selector) {
        selectorNames.push(selector.name);
    });

    for (var pair of formDataEntries(form)) {
        formDataArray.push(pair);
    }

    let existingNames = formDataArray.map(entry => entry[0]);
    selectorNames = [...new Set(selectorNames)];

    selectorNames.forEach(function (name) {
        let newEntry = [name, ""];
        if(!existingNames.includes(name)) {
            formDataArray.push(newEntry);
        } else {
            formDataArray.filter(item => item !== newEntry);
        }
    });
    return formDataArray;
}

function fetchPois(baseElement, form, map) {
    let mapCanvas = findIn('.js-ajax-form-map-leaflet__canvas', baseElement);
    let mapUrl = mapCanvas.getAttribute('data-form-map-url');

    fetch(mapUrl, {
        body: new URLSearchParams(new FormData(form))
    })
        .then(response => response.json())
        .then((marker) => {
            map.setMarker( marker.pois);
        });
}

function initMapCanvas(baseElement) {

    let form = findIn('.js-ajax-form-map-leaflet__form', baseElement);
    let mapCanvas = findIn('.js-ajax-form-map-leaflet__canvas', baseElement);

    createLeafletMap(mapCanvas,{
        tilelayer: 'https://maps{s}.wien.gv.at/basemap/geolandbasemap/{type}/google3857/{z}/{y}/{x}.{format}',
        leafletOptions:  {
            attribution: 'Datenquelle: <a href="https://www.basemap.at">basemap.at</a>',
            subdomains: ["", "1", "2", "3", "4"],
            type: 'normal',
            format: 'png',
            bounds: [[46.35877, 8.782379], [49.037872, 17.189532]]
        },
        mapOptions: {
            center: {lat: 47.836249, lng: 13.0615383},
            zoom: 15,
            zoomControl: true,
            maxZoom: 18,
        },
        poiStyles: () => createPoiStyles(),
        infoBoxOptions,
        clustering: false,
        clusteringOptions: () => clusteringOptions(),
        onActivateMarker: (marker, api) => onActivateMarker(marker, api),
        onDeactivateMarker: (marker, api) => onDeactivateMarker( marker, api),
    });


    getApi(mapCanvas).then((map) => {
        fetchPois(baseElement, form, map);
    });

}

function clusteringOptions () {
    return {
        showCoverageOnHover: false,
        iconCreateFunction: function (cluster) {
            return L.divIcon({
                iconSize: [46, 46],
                iconAnchor: [23, 23],
                className: 'marker-cluster',
                html: '<img class="marker-cluster__img" src="/static/img/map/cluster.png"/><span class="marker-cluster__count">' + cluster.getChildCount() + '</span>'
            });
        }
    };
}

function createPoiStyles() {

    let iconDefaultUrl = '/static/img/map/marker-uab.png';
    let iconActiveUrl = '/static/img/map/marker-uab-highlighted.png';

    if(_config.pzg){
        iconDefaultUrl = '/static/img/map/pzg/marker-pzg.svg';
        iconActiveUrl = '/static/img/map/pzg/marker-pzg-highlighted.svg';
    }

    return {
        main: {
            default: L.icon({
                iconUrl: iconDefaultUrl,
                iconSize: [56, 82],
                iconAnchor: [28, 82],
                popupAnchor: [0, -80],
            }),
            active: L.icon({
                iconUrl: iconActiveUrl,
                iconSize: [56, 82],
                iconAnchor: [28, 82],
                popupAnchor: [0, -80],
            })

        },
        basic: {
            default: L.icon({
                iconUrl: iconDefaultUrl,
                iconSize: [46, 67],
                iconAnchor: [23, 67],
                popupAnchor: [0, -65],
            }),
            active: L.icon({
                iconUrl: iconActiveUrl,
                iconSize: [46, 67],
                iconAnchor: [23, 67],
                popupAnchor: [0, -65],
            })
        },
        market: {
            default: L.icon({
                iconUrl: '/static/img/map/marker-market.svg',
                iconSize: [38, 58],
                iconAnchor: [19, 58],
                popupAnchor: [0, -55],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/marker-market.svg',
                iconSize: [38, 58],
                iconAnchor: [19, 58],
                popupAnchor: [0, -55],

            })
        },
        shop: {
            default: L.icon({
                iconUrl: '/static/img/map/marker-shop.svg',
                iconSize: [38, 58],
                iconAnchor: [19, 58],
                popupAnchor: [0, -55],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/marker-shop.svg',
                iconSize: [38, 58],
                iconAnchor: [19, 58],
                popupAnchor: [0, -55],
            })
        },
        bar: {
            default: L.icon({
                iconUrl: '/static/img/map/marker-bar.svg',
                iconSize: [38, 58],
                iconAnchor: [19, 58],
                popupAnchor: [0, -55],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/marker-bar.svg',
                iconSize: [38, 58],
                iconAnchor: [19, 58],
                popupAnchor: [0, -55],
            })
        },
        basicCrown: {
            default: L.icon({
                iconUrl: '/static/img/map/marker-direct-crown.svg',
                iconSize: [46, 67],
                iconAnchor: [23, 67],
                popupAnchor: [0, -65],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/marker-direct-crown.svg',
                iconSize: [46, 67],
                iconAnchor: [23, 67],
                popupAnchor: [0, -65],
            })
        },
        basicBio: {
            default: L.icon({
                iconUrl: '/static/img/map/marker-direct-bio.svg',
                iconSize: [52, 58],
                iconAnchor: [26, 58],
                popupAnchor: [-8, -55],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/marker-direct-bio.svg',
                iconSize: [52, 58],
                iconAnchor: [26, 58],
                popupAnchor: [-8, -55],
            })
        },
        basicBioCrown: {
            default: L.icon({
                iconUrl: '/static/img/map/marker-direct-bio-crown.svg',
                iconSize: [60, 75],
                iconAnchor: [30, 75],
                popupAnchor: [0, -72],
            }),
            active: L.icon({
                iconUrl: '/static/img/map/marker-direct-bio-crown.svg',
                iconSize: [60, 75],
                iconAnchor: [30, 75],
                popupAnchor: [0, -72],
            })
        }
    };

}


function onActivateMarker(marker, api) {
    if(marker.detailInfoBoxUrl) {
        let infoBoxPromise = api.showInfoBoxByMarker(
            marker,
            `<div class="my-2">
                <div class="loading-spinner" aria-label="Loading...">
                    <div class="loading-spinner__item loading-spinner__item--1"></div>
                    <div class="loading-spinner__item loading-spinner__item--2"></div>
                    <div class="loading-spinner__item loading-spinner__item--3"></div>
                </div>
            </div>`
        );

        let contentPromise = fetch(marker.detailInfoBoxUrl, {
            method: 'GET',
            headers: {"content-type": "application/json"}
        }).then((res) => {
            return res.json()
        });


        Promise.all([infoBoxPromise, contentPromise]).then(([infoBox, response]) => {
            marker.bindPopup(response.content).openPopup();
        });
    }
}

function onDeactivateMarker(marker, mapObj) {
    // let detailArea = $('.js-leaflet-map__detail-area');
    // detailArea.html("");
}

